module.exports = __webpack_public_path__ + "static/media/galaxyCompressed.d0fb5d40.jpg";